import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';

const getAttendees = (booking) => {
  return booking?.attendees || booking?.number_of_guests;
};

export const BookingSummaryAttendees = ({ currentBooking, pendingBooking }) => {
  const currentAttendees = getAttendees(currentBooking);
  const pendingAttendees = getAttendees(pendingBooking);
  const attendeesUpdated =
    !isEmpty(pendingBooking) && currentAttendees !== pendingAttendees;

  return (
    <BookingSummaryItem
      testingId='booking-summary-attendees'
      label={
        <FormattedMessage
          id='inbox.summary_props.attendees'
          defaultMessage='Attendees'
        />
      }
      updatedContent={
        attendeesUpdated && (
          <FormattedMessage
            id='inbox.summary_props.attendees_people'
            defaultMessage='{attendees} people'
            values={{
              attendees: pendingAttendees
            }}
          />
        )
      }
    >
      {!!currentAttendees ? (
        <FormattedMessage
          id='inbox.summary_props.attendees_people'
          defaultMessage='{attendees} people'
          values={{ attendees: currentAttendees }}
        />
      ) : (
        <FormattedMessage
          id='inbox.summary_props.not_specified'
          defaultMessage='Not specified'
        />
      )}
    </BookingSummaryItem>
  );
};

BookingSummaryAttendees.propTypes = {
  currentBooking: PropTypes.object.isRequired,
  pendingBooking: PropTypes.object
};
